<ng-container *ngIf="facade.detail$ | async as detail; else stateTpl">
    <div class="property-detail">

        <!-- GALERÍA -->
        <app-image-gallery
            [images]="(facade.gallery$ | async) ?? []"
            [badge]="detail.badge"
        ></app-image-gallery>

        <!-- CABECERA: INFO + ACCIONES -->
        <div class="property-header">
            <app-property-info [info]="detail.header"></app-property-info>
            <app-property-actions
                (onFavorite)="favorite()"
                (onShare)="share()"
            ></app-property-actions>
        </div>

        <!-- DETALLES (m² / hab / baños) -->
        <app-property-summary [summary]="detail.summary"></app-property-summary>

        <!-- CARACTERÍSTICAS -->
        <app-property-features [featureGroups]="(facade.features$ | async) ?? []"></app-property-features>

        <!-- UBICACIÓN -->
        <app-property-location
            *ngIf="facade.location$ | async as loc"
            [location]="loc"
        ></app-property-location>

        <!-- PAPELES -->
        <app-property-documents [documents]="(facade.documents$ | async) ?? []"></app-property-documents>

        <!-- DESCUBRE MÁS -->
        <app-related-properties
            [properties]="(facade.related$ | async) ?? []"
            (select)="openProperty($event)"
        ></app-related-properties>
    </div>
</ng-container>

<ng-template #stateTpl>
    <div class="detail-state">
        <p-progressSpinner *ngIf="facade.loading$ | async" strokeWidth="4"></p-progressSpinner>

        <div class="detail-error" *ngIf="(facade.error$ | async) as err">
            <p>{{ err }}</p>
            <button pButton type="button" label="Reintentar" (click)="reload()"></button>
        </div>
    </div>
</ng-template>
